import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import st from './AddEbookCourse.module.scss'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { localisationMaster } from 'Localisation/Localisation'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import useLocalization from 'hooks/useLocalization'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import { observer } from 'mobx-react'

const AddEbookCourse = ({ students }) => {
  const [ebook, setEbook] = useState({})
  const [registerSections, setRegisterSections] = useState([])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      select_course: 'Select a course',
      section: 'Section',
      select_section: 'Select section',
      course_start_date: 'Course start date',
      today: 'Today',
      course_end_date: 'Course end date',
      add_ebook_for_students:
        'Add an e-book for all current students in the group',
      start_date_time: 'Start Date',
      end_date_time: 'End Date',
      reset: 'Reset',
      select_registers_type: 'Select Registers Type',
    },
  })

  const { modalValues, changeValue, changeValues, check } = asideModalStore

  useEffect(() => {
    if (!modalValues.ebook_id) return

    const apiConf = {
      method: 'get',
      link: 'ebooks/ebook_register_chapters',
      params: {
        ebook_id: modalValues.ebook_id,
        limit: 999,
      },
    }

    superAxiosRequest(apiConf)
      .then((res) => {
        setRegisterSections(res.data.result)
      })
      .catch(() => {})
  }, [modalValues.ebook_id])

  return (
    <div className={st.addEbook}>
      <FormField>
        <FormLabel isRequired>{translate?.select_course}:</FormLabel>
        <SelectCustom
          placeholder={localisationMaster(
            'choose_course',
            'groups/group',
            'course_to_group',
          )}
          apiLink='ebooks/books'
          apiConfParams={{
            is_catalog: true,
            limit: 999,
          }}
          sortKey='name'
          valueID={modalValues.ebook_id}
          onChange={(o) => {
            changeValue(o.id, 'ebook_id')
            setEbook(o)
          }}
          error={check('ebook_id')}
          isSearchable
        />
      </FormField>
      <div className={st.categoryField}>
        <div className={st.info}>
          <span>{localisationMaster('text_81', 'groups/all-groups')}:</span>
          <span>{ebook.course_level || '...'}</span>
        </div>
        <div className={st.info}>
          <span>{localisationMaster('text_82', 'groups/all-groups')}:</span>
          <span>{ebook.skill_level || '...'}</span>
        </div>
        <div className={st.info}>
          <span>
            {localisationMaster(
              'count_lessons',
              'groups/group',
              'course_to_group',
            )}
            :
          </span>
          <span>{ebook.chapters_count || '...'}</span>
        </div>
      </div>
      <FormField>
        <FormLabel isRequired>{translate?.select_registers_type}:</FormLabel>
        <SelectCustom
          placeholder={translate?.select_registers_type}
          options={registerSections}
          valueID={modalValues.registerchapters_id}
          onChange={(o) => changeValue(o.id, 'registerchapters_id')}
          error={check('registerchapters_id')}
        />
      </FormField>
      <div className={st.time}>
        <FormDateSelector
          placeholder={translate?.start_date_time}
          isRequired={false}
          button={{ name: translate?.today, action: 'today' }}
          label={translate?.course_start_date + ':'}
          onChange={(val) =>
            changeValue(dateFormat(val, 'YYYY-mm-dd'), 'start_date')
          }
          value={modalValues.start_date || ''}
          error={check('start_date')}
        />
        <FormDateSelector
          placeholder={translate?.end_date_time}
          isRequired={false}
          button={{ name: translate?.reset, action: 'reset' }}
          label={translate?.course_end_date + ':'}
          onChange={(val) =>
            changeValue(
              val ? dateFormat(val, 'YYYY-mm-dd') : undefined,
              'end_date',
            )
          }
          minDate={new Date(modalValues.start_date)}
          value={modalValues.end_date || ''}
        />
      </div>
      <ToggleCheckbox
        label={translate?.add_ebook_for_students}
        checked={modalValues.add_to_student}
        onChange={() => {
          changeValues({
            ...modalValues,
            add_to_student: !modalValues.add_to_student,
            students: students,
          })
        }}
      />
    </div>
  )
}

export default observer(AddEbookCourse)
